import styled from 'styled-components';

export const BreadCrumbsContainer = styled.div`
  margin-bottom: 10px;
`;

export const BreadCrumbsItem = styled.small`
  color: #516f90;
`;
